import { defineStore } from 'pinia'
import { ref } from 'vue'
import { usePage } from '@inertiajs/vue3'

export const useAdStore = defineStore('ad-store', () => {

	const settings = ref(usePage().props.settings)
	const counter = ref(settings.value.ads_pause)
	const locked = ref(false)
	const ads = ref(usePage().props.ads)
	const ad = ref(null)
	const isShow = ref(false)

	const weighted_random = () => {
		let i

		let probabilities = ads.value.probabilities

		if (!probabilities || probabilities.length === 0) {
			return null
		}

		let weights = [probabilities[0].weight]

		for (i = 1; i < probabilities.length; i++) {
			weights[i] = probabilities[i].weight + weights[i - 1]
		}

		let total = weights[weights.length - 1]

		// No ad type has a weight (misconfigured) — show nothing instead of crashing.
		if (total <= 0) {
			return null
		}

		let random = Math.random() * total

		for (i = 0; i < weights.length; i++) {
			if (weights[i] > random) {
				break
			}
		}

		return probabilities[i].src
	}

	const getAd = () => {

		let selected = weighted_random()

		switch (selected) {
			case 'custom-script':
				ad.value = {
					src: 'custom-script',
				}
				break
			case 'dsc':
				window.axios.get(route('api.ad.dsc')).then(response => {
					ad.value = {
						src: 'dsc',
						data: response.data
					}
				})
				break
			case 'stripchat':
				window.axios.get(route('api.ad.stripchat')).then(response => {
					ad.value = {
						src: 'stripchat',
						data: response.data
					}
				})
				break
			case 'google-ads':
				ad.value = {
					src: 'google',
				}
				break
			case 'vast':
				window.axios.get(route('api.ad.vast')).then(response => {
					ad.value = {
						src: 'vast',
						data: response.data
					}
				})
				break
		}
	}

	const lockAd = () => {
		locked.value = true
	}

	const releaseAd = () => {
		locked.value = false
	}

	return {
		ads,
		ad,
		counter,
		locked,
		isShow,
		getAd,
		lockAd,
		releaseAd
	}
})
